import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import {
    phases,
    licenses,
    proLicenses,
    formats,
    steps,
    phasesDisplay,
    constToCSS
} from "../reducers/download";

import DownloadFlowLicenseSwitch from "./download-flow/download-flow-license-switch";
import DownloadFlowErrors from "./download-flow/download-flow-errors";
import IconPaymentForm from "./download-flow/phase-icon-payment";
import InitialPhase from "./download-flow/phase-initial";
import SelectLicense from "./download-flow/phase-select-license";
import SelectPurchaseType from "./download-flow/phase-select-purchase-type";
import DownloadReady from "./download-flow/phase-download-ready";
import UseIconCredit from "./download-flow/phase-use-prepaid";
import UpsellPhase from "./download-flow/phase-upsell";
import IconTitle from "./download-flow/icon-title";
import IconCreator from "./download-flow/icon-creator";
import IconMicroData from "./download-flow/icon-micro-data";

class IconDownloadFlow extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.icon) {
            if (
                !this.props.download.pendingDownload ||
                this.props.download.pendingDownload.id != this.props.icon.id
            ) {
                this.props.downloadSetFlowActive(this.props.icon);
            }
        }
    }
    componentWillUnmount() {
        this.props.downloadResetFlow();
        if (this.props.showInModal) {
            this.props.dismissModal();
        }
    }

    shouldShowInModal(props) {
        let { download } = props;

        let { status } = download;

        if (!props.showInModal) {
            return false;
        }

        if (download.isPremiumUser) {
            return false;
        }

        return (
            status &&
            status != phases.INITIAL &&
            status != phases.DOWNLOAD_READY
        );
    }

    render() {
        let { download } = this.props;
        let { status, license } = download;
        let { pendingDownload } = this.props.download;

        if (!this.props.icon && status != phases.INITIAL) {
            return null;
        }

        if (this.shouldShowInModal(this.props)) {
            return null;
        }

        let Phase = Flow[status];

        if (!Phase) {
            return <span></span>;
        }

        let phaseClass = status && `phase-${constToCSS(status)}`;
        let hasCollection =
            pendingDownload &&
            pendingDownload.collections &&
            pendingDownload.collections.length;
        let classes = classnames(
            "download-flow",
            phaseClass,
            license && pendingDownload && `with-license-${constToCSS(license)}`,
            {
                "with-pro-license":
                    pendingDownload && proLicenses.includes(license),
                "with-collection": hasCollection,
                "no-collection": !hasCollection
            }
        );

        let licenseSwitch;
        if (status != phases.UPSELL) {
            licenseSwitch = (
                <DownloadFlowLicenseSwitch
                    download={this.props.download}
                    onLicenseClick={this.props.downloadJumpToLicense}
                />
            );
        }

        let errorDisplay;
        if (!Phase.handlesOwnErrors) {
            errorDisplay = (
                <DownloadFlowErrors error={this.props.download.error} />
            );
        }

        return (
            <section className={classes}>
                <IconMicroData icon={this.props.icon} />
                <IconTitle {...this.props} />
                <IconCreator {...this.props} />
                <div className="phase-container">
                    {licenseSwitch}
                    <Phase {...this.props} />
                    {errorDisplay}
                </div>
            </section>
        );
    }
}

const Flow = {
    [phases.INITIAL]: InitialPhase,
    [phases.SELECT_LICENSE]: SelectLicense,
    [phases.DOWNLOAD_READY]: DownloadReady,
    [phases.UPSELL]: UpsellPhase,
    [phases.SELECT_PURCHASE_TYPE]: SelectPurchaseType,
    [phases.PAYMENT]: IconPaymentForm,
    [phases.USE_PREPAID]: UseIconCredit
};

function mapStateToProps(state, ownProps) {
    let { download, editor } = state;

    return {
        download,
        editor
    };
}

export default connect(mapStateToProps, {
    fetchViewMoreIcons: actions.fetchViewMoreIcons,
    downloadRequest: actions.downloadRequest,
    downloadSelectLicense: actions.downloadSelectLicense,
    downloadCommitLicense: actions.downloadCommitLicense,
    downloadStart: actions.downloadStart,
    downloadSetFlowActive: actions.downloadSetFlowActive,
    downloadResetFlow: actions.downloadResetFlow,
    downloadRepurchase: actions.downloadRepurchase,
    downloadJumpToLicense: actions.downloadJumpToLicense,
    downloadResetAttribution: actions.downloadResetAttribution,
    downloadDoUpsell: actions.downloadDoUpsell,
    downloadNoPremiumFeatures: actions.downloadNoPremiumFeatures,
    showModal: actions.showModal,
    dismissModal: actions.dismissModal,
    stripeGetSavedCard: actions.stripeGetSavedCard,
    editorTransform: actions.editorTransform
})(IconDownloadFlow);
